module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Pixels-de3cda20462606096753545430553dfd.svg";